import {createSlice} from '@reduxjs/toolkit';


let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

const initialState = {
    responsive_ui : viewportWidth <= 1400 ? false : true,
    responsive_ui_userList : true,
    responsive_ui_chatArea : viewportWidth <= 720 ? false : true,
    send_message_ui : false
};

const chat_ui = createSlice({
    name: 'chat_ui',
    initialState,
    reducers: {
        responsiveUI : (state , {payload}) => {
            state.responsive_ui = payload;
        },
        responsiveUI_userList : (state , {payload}) => {
            state.responsive_ui_userList = payload;
        },
        responsiveUI_chatArea : (state , {payload}) => {
            state.responsive_ui_chatArea = payload;
        },
        sending_message_ui : (state , {payload}) => {
            state.send_message_ui = payload;
        },
    }
})


export const {responsiveUI, responsiveUI_userList, responsiveUI_chatArea,sending_message_ui} = chat_ui.actions;
export default chat_ui.reducer;